"use strict";

var _toConsumableArray = require("/vercel/path1/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _slicedToArray = require("/vercel/path1/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _regeneratorRuntime = require("/vercel/path1/node_modules/@babel/runtime/regenerator/index.js");

require("core-js/modules/es.object.from-entries.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNotEmptyObject = exports.slash = exports.isPathParameter = exports.readFileAsStringSync = exports.isSingular = exports.validateMimeTypeOAS3 = exports.validateMimeType = exports.splitCamelCaseIntoWords = exports.omitObjectProps = exports.pickObjectProps = exports.match = exports.readFileFromUrl = exports.isEmptyArray = exports.isEmptyObject = exports.isPlainObject = exports.notUndefined = exports.loadYaml = exports.popStack = exports.pushStack = exports.stringifyYaml = exports.parseYaml = void 0;

var fs = require("fs");

var minimatch = require("minimatch");

var node_fetch_1 = require("node-fetch");

var pluralize = require("pluralize");

var js_yaml_1 = require("./js-yaml");

var js_yaml_2 = require("./js-yaml");

Object.defineProperty(exports, "parseYaml", {
  enumerable: true,
  get: function get() {
    return js_yaml_2.parseYaml;
  }
});
Object.defineProperty(exports, "stringifyYaml", {
  enumerable: true,
  get: function get() {
    return js_yaml_2.stringifyYaml;
  }
});

function pushStack(head, value) {
  return {
    prev: head,
    value: value
  };
}

exports.pushStack = pushStack;

function popStack(head) {
  var _a;

  return (_a = head === null || head === void 0 ? void 0 : head.prev) !== null && _a !== void 0 ? _a : null;
}

exports.popStack = popStack;

function loadYaml(filename) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var contents;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fs.promises.readFile(filename, 'utf-8');

          case 2:
            contents = _context.sent;
            return _context.abrupt("return", js_yaml_1.parseYaml(contents));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

exports.loadYaml = loadYaml;

function notUndefined(x) {
  return x !== undefined;
}

exports.notUndefined = notUndefined;

function isPlainObject(value) {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}

exports.isPlainObject = isPlainObject;

function isEmptyObject(value) {
  return isPlainObject(value) && Object.keys(value).length === 0;
}

exports.isEmptyObject = isEmptyObject;

function isEmptyArray(value) {
  return Array.isArray(value) && value.length === 0;
}

exports.isEmptyArray = isEmptyArray;

function readFileFromUrl(url, config) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var headers, _iterator, _step, header, req;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            headers = {};
            _iterator = _createForOfIteratorHelper(config.headers);

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                header = _step.value;

                if (match(url, header.matches)) {
                  headers[header.name] = header.envVariable !== undefined ? process.env[header.envVariable] || '' : header.value;
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            _context2.next = 5;
            return (config.customFetch || node_fetch_1.default)(url, {
              headers: headers
            });

          case 5:
            req = _context2.sent;

            if (req.ok) {
              _context2.next = 8;
              break;
            }

            throw new Error("Failed to load ".concat(url, ": ").concat(req.status, " ").concat(req.statusText));

          case 8:
            _context2.next = 10;
            return req.text();

          case 10:
            _context2.t0 = _context2.sent;
            _context2.t1 = req.headers.get('content-type');
            return _context2.abrupt("return", {
              body: _context2.t0,
              mimeType: _context2.t1
            });

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}

exports.readFileFromUrl = readFileFromUrl;

function match(url, pattern) {
  if (!pattern.match(/^https?:\/\//)) {
    // if pattern doesn't specify protocol directly, do not match against it
    url = url.replace(/^https?:\/\//, '');
  }

  return minimatch(url, pattern);
}

exports.match = match;

function pickObjectProps(object, keys) {
  return Object.fromEntries(keys.filter(function (key) {
    return key in object;
  }).map(function (key) {
    return [key, object[key]];
  }));
}

exports.pickObjectProps = pickObjectProps;

function omitObjectProps(object, keys) {
  return Object.fromEntries(Object.entries(object).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        key = _ref2[0];

    return !keys.includes(key);
  }));
}

exports.omitObjectProps = omitObjectProps;

function splitCamelCaseIntoWords(str) {
  var camel = str.split(/(?:[-._])|([A-Z][a-z]+)/).filter(Boolean).map(function (item) {
    return item.toLocaleLowerCase();
  });
  var caps = str.split(/([A-Z]{2,})/).filter(function (e) {
    return e && e === e.toUpperCase();
  }).map(function (item) {
    return item.toLocaleLowerCase();
  });
  return new Set([].concat(_toConsumableArray(camel), _toConsumableArray(caps)));
}

exports.splitCamelCaseIntoWords = splitCamelCaseIntoWords;

function validateMimeType(_ref3, _ref4, allowedValues) {
  var type = _ref3.type,
      value = _ref3.value;
  var report = _ref4.report,
      location = _ref4.location;
  var ruleType = type === 'consumes' ? 'request' : 'response';
  if (!allowedValues) throw new Error("Parameter \"allowedValues\" is not provided for \"".concat(ruleType, "-mime-type\" rule"));
  if (!value[type]) return;

  var _iterator2 = _createForOfIteratorHelper(value[type]),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var mime = _step2.value;

      if (!allowedValues.includes(mime)) {
        report({
          message: "Mime type \"".concat(mime, "\" is not allowed"),
          location: location.child(value[type].indexOf(mime)).key()
        });
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
}

exports.validateMimeType = validateMimeType;

function validateMimeTypeOAS3(_ref5, _ref6, allowedValues) {
  var type = _ref5.type,
      value = _ref5.value;
  var report = _ref6.report,
      location = _ref6.location;
  var ruleType = type === 'consumes' ? 'request' : 'response';
  if (!allowedValues) throw new Error("Parameter \"allowedValues\" is not provided for \"".concat(ruleType, "-mime-type\" rule"));
  if (!value.content) return;

  for (var _i = 0, _Object$keys = Object.keys(value.content); _i < _Object$keys.length; _i++) {
    var mime = _Object$keys[_i];

    if (!allowedValues.includes(mime)) {
      report({
        message: "Mime type \"".concat(mime, "\" is not allowed"),
        location: location.child('content').child(mime).key()
      });
    }
  }
}

exports.validateMimeTypeOAS3 = validateMimeTypeOAS3;

function isSingular(path) {
  return pluralize.isSingular(path);
}

exports.isSingular = isSingular;

function readFileAsStringSync(filePath) {
  return fs.readFileSync(filePath, 'utf-8');
}

exports.readFileAsStringSync = readFileAsStringSync;

function isPathParameter(pathSegment) {
  return pathSegment.startsWith('{') && pathSegment.endsWith('{');
}

exports.isPathParameter = isPathParameter;
/**
 * Convert Windows backslash paths to slash paths: foo\\bar ➔ foo/bar
 */

function slash(path) {
  var isExtendedLengthPath = /^\\\\\?\\/.test(path);

  if (isExtendedLengthPath) {
    return path;
  }

  return path.replace(/\\/g, '/');
}

exports.slash = slash;

function isNotEmptyObject(obj) {
  return !!obj && Object.keys(obj).length > 0;
}

exports.isNotEmptyObject = isNotEmptyObject;